export default [
  {
    title: 'ข้อมูลการขอคืนเงิน',
    route: 'refund-management',
    icon: 'RepeatIcon',
    action: 'all',
    resource: 'admin',
  },
]
